/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

// Component imports
import { Form } from 'antd';
import EntryPointSelect from '../../../Forms/Fields/EntryPointSelect';

// Misc imports
import { useBotLanguage } from '../../../../utils/hooks/useBotLanguage';

const JumpNodeForm = () => {
  const { t } = useTranslation();
  const { isEditingPrimaryLanguage } = useBotLanguage();

  return (
    <Fragment>
      <Form.Item
        label={t('Flow to redirect to')}
        name={['data', 'jumpTo']}
        rules={[{ required: true, message: t('Flow cannot be blank.') }]}
        className="mb-0"
      >
        <EntryPointSelect
          size="large"
          disabled={!isEditingPrimaryLanguage}
          getPopupContainer={() => document.body} //reset drop-menu position fix to default behavior
        />
      </Form.Item>
    </Fragment>
  );
};

export default JumpNodeForm;
